import * as React from 'react';

import { ScrollableSlider } from '../../components/ScrollableSlider';
import { useScrollableSliderSize, useSlideClick } from './hooks';

export interface IScrollableSliderContainerProps<TItem> {
  slides: TItem[];
  renderSlide(item: TItem, index: number): React.ReactNode;
  gap?: number;
  visibleSlides?: number;
}

export function ScrollableSliderContainer<TItem>({
  slides,
  renderSlide,
  gap = 0,
  visibleSlides = 1,
}: IScrollableSliderContainerProps<TItem>) {
  const { refsDict, size } = useScrollableSliderSize({ slides, gap });
  const { onSlideMouseDown, onSlideClickCapture } = useSlideClick();

  const renderedItems = slides.map((slide, index) => {
    return (
      <div key={index} ref={refsDict[index]}>
        {renderSlide(slide, index)}
      </div>
    );
  });

  return (
    <ScrollableSlider
      slides={renderedItems}
      onSlideMouseDown={onSlideMouseDown}
      onSlideClickCapture={onSlideClickCapture}
      size={size}
      visibleSlides={visibleSlides}
    />
  );
}
